
import { Component, Vue } from 'vue-property-decorator';
import { AuthStore } from "@/store/modules/Auth";
@Component
export default class User extends Vue {
    async userExit(): Promise<void> {
        await AuthStore.logout()
    }
}
